// @ts-check

import { Link, Typography } from '@bonprix/design-system';
// @ts-expect-error Don't know how to fix this using JSDoc
import Url from '@core/scripts/helper/url';
import classNames from 'classnames';
import './jsdoc-types.js'
import { getSlugFromNavigationItem, navigationItemIsCurrentPage, navigationItemIsParentPage } from './helpers.jsx';

/**
 * @param {Object} props
 * @param {NavigationEntry} props.cdaEntry
 */
export const ServicePageNavigation = ({ cdaEntry }) => {
	const href = cdaEntry.fields.slug ? new URL(Url.toAbsolute(cdaEntry.fields.slug)) : null;

	return (
		<div className="service-page-navigation">
			<a href={ href?.toString() } className="service-page-navigation__title-link">
				<Typography variant="bonprix-h3">{cdaEntry.fields.title}</Typography>
			</a>

			<nav className="service-page-navigation__items">
				<ul>
					{cdaEntry.fields.items?.map(entry => <SectionOrItem key={ entry.sys.id } entry={ entry } />)}
				</ul>
			</nav>
		</div>
	)
}

/**
 * @param {Object} props
 * @param {NavigationSectionEntry | NavigationItemEntry} props.entry
 */
const SectionOrItem = ({ entry }) => {
	if (entry.sys.contentType.sys.id === "navigationSection")
		// @ts-expect-error Don't know how to fix this using JSDoc
		return <Section key={ entry.sys.id } section={ entry } />


	if (entry.sys.contentType.sys.id === "navigationItem")
		// @ts-expect-error Don't know how to fix this using JSDoc
		return <Item key={ entry.sys.id } item={ entry } />

	// @ts-expect-error Don't know how to fix this using JSDoc
	console.warn(`[Service Page Navigation] Unknown entry type: ${entry.sys.contentType.sys.id}`);
	return null;
}

/**
 * @param {Object} props
 * @param {NavigationSectionEntry} props.section
 */
const Section = ({ section }) => {
	return section.fields.items?.map((entry, index) => <Item key={ entry.sys.id } item={ entry } isSectionStart={index === 0} isSectionEnd={index === section.fields.items.length - 1} />)
}

/**
 * @param {Object} props
 * @param {NavigationItemEntry} props.item
 * @param {boolean} [props.isSectionStart]
 * @param {boolean} [props.isSectionEnd]
 */
const Item = ({ item, isSectionStart, isSectionEnd }) => {
	const slug = getSlugFromNavigationItem(item);
	if (!slug) {
		console.warn(`[Service Page Navigation] Navigation item without slug: ${item.sys.id}`);
		return null;
	}

	const isActive = navigationItemIsCurrentPage(item);
	const isActiveParent = navigationItemIsParentPage(item);

	return <li className={classNames("service-page-navigation__item", {
		"service-page-navigation__item--active underline": isActive,
		"service-page-navigation__item--section-start": isSectionStart,
		"service-page-navigation__item--section-end": isSectionEnd,
	})}>
		<Link href={ Url.toAbsolute(slug) } hideUnderline>
			{ item.fields.title }
		</Link>

		{isActiveParent && item.fields.items?.length > 0 && <ul className="service-page-navigation__sub-items">
			{item.fields.items.map(subItem => <Item key={ subItem.sys.id } item={ subItem } />)}
		</ul>}
	</li>
}
